import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ExternalPhoneNumberPageComponent } from "./externalPhoneNumberPage/external-phone-number-page.component";
import { ExternalPhoneNumberSetupComponent } from "./externalPhoneNumberSetup/external-phone-number-setup.component";

const routes: Routes = [
  {
    path: "",
    component: ExternalPhoneNumberPageComponent
  },
  {
    path: "setup",
    component: ExternalPhoneNumberSetupComponent,
    runGuardsAndResolvers: "always",
    data: { title: "External phone number setup" }
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class ExternalPhoneNumberRoutingModule {}
